import React from 'react';
import PropTypes from 'prop-types';
import { Dialog } from 'day8-ui';
import { IoMdTime } from "@react-icons/all-files/io/IoMdTime";
import WaitingListForm from './WaitingListForm';
const WaitingListModal = ({ waitingListInfo, on, toggle }) => {
  return (
    <Dialog
      open={on}
      onOpenChange={toggle}
      title={<h2 className="dui-text-2xl dui-flex dui-items-center dui-gap-2 dui-mb-4"><IoMdTime />Waitlist</h2>}
      scrollable
    >
      <WaitingListForm {...waitingListInfo} toggle={toggle} />
    </Dialog>
  );
};
WaitingListModal.propTypes = {
  waitingListInfo: PropTypes.object,
  on: PropTypes.bool,
  toggle: PropTypes.func
};
export default WaitingListModal;